var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"sticky-bar py-2",class:{'dense': _vm.dense, 'mb-6': !_vm.dense },attrs:{"outlined":_vm.outlined,"flat":""}},[_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }